import React from 'react';
import PropTypes from 'prop-types';
import { partial } from 'underscore';

import i18n from 'utils/translate';
import Button from 'components/Button';

import './styles.scss';

function handleNavEvent(go, e) {
  e.preventDefault();
  e.stopPropagation();

  if (go instanceof Function) {
    go();
  }
}

const linkType = PropTypes.shape({
  url: PropTypes.string,
  go: PropTypes.func
});

NavigationButtons.propTypes = {
  backLink: linkType,
  nextLink: linkType,
  nextText: PropTypes.string,
  backText: PropTypes.string,
  canContinue: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func
};

export default function NavigationButtons({
  backLink,
  nextLink = {},
  nextText = i18n('Weiter'),
  backText = i18n('Zurück'),
  canContinue = true,
  loading = false,
  onClick
}) {
  const nextButton = (
    <Button
      className="navigation-buttons__continue"
      disabled={!canContinue}
      label={nextText}
      loading={loading}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    />
  );

  return (
    <div className="navigation-buttons row">
      <div className="col-xs-12">
        {backLink && (
          <a
            className="navigation-buttons__back"
            href={backLink.url}
            onClick={backLink.go && partial(handleNavEvent, backLink.go)}
          >
            {backText}
          </a>
        )}
        <a
          className="navigation-buttons__continue"
          onClick={e => {
            if (loading || !canContinue) {
              return;
            }

            handleNavEvent(nextLink.go, e);
          }}
          href={nextLink.url}
        >
          {nextButton}
        </a>
      </div>
    </div>
  );
}
